import './Banner.css'

const Banner = () => {
    return (<header className="cabecalho">
        <img src='/images/banner.png' alt='Logo do Organo'/>
    </header>)
}

export default Banner